import type { IconName } from '@fortawesome/fontawesome-common-types';
import { Link } from 'gatsby';
import React from 'react';

import MenuItem from '@components/MenuItem/index';

interface DrawerItemIcon {
  color: string;
  name: IconName;
}

interface DrawerItem {
  icon: DrawerItemIcon;
  text: string;
  isSelected: boolean;
  to: string;
  isHidden?: boolean;
}

interface DrawerSectionProps {
  title: string;
  items: DrawerItem[];
}

function DrawerSection({ title, items }: DrawerSectionProps) {
  return (
    <>
      <h3>{title}</h3>
      {items
        .filter((item) => !item.isHidden)
        .map(({ icon, isSelected, text, to }, index) => (
          <Link key={`item-${index}`} to={to}>
            <MenuItem
              icon={[{ iconColor: icon.color, iconName: icon.name }]}
              selected={isSelected}
              text={text}
            />
          </Link>
        ))}
    </>
  );
}

export default DrawerSection;
export type { DrawerItem, DrawerItemIcon, DrawerSectionProps };
